import axios from 'axios';
import { getUserInfo, clearUserInfo, getDevModeState } from '@/services/cookieService';

let headers = {
  'Content-Type': 'application/json', // Default header
};

// Create an axios instance with a base URL and default headers
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL || (process.env.NODE_ENV === 'production' 
    ? 'https://ai.redxvpp.com' 
    : ''),  // Use VUE_APP_API_URL if set, otherwise use environment-based defaults
  headers: {
    'Content-Type': 'application/json', // Default header
  },
  withCredentials: true, // Include credentials
  timeout: 60000, // Set a timeout of 30 seconds
  maxContentLength: 50 * 1024 * 1024,
  maxBodyLength: 50 * 1024 * 1024,
});

// Request interceptor to add auth token or other modifications if needed
apiClient.interceptors.request.use(
  config => {
    const cookieData = getUserInfo();
    if (cookieData) {
      config.headers.id = cookieData.id;
      config.headers.email = cookieData.email;
      config.headers.token = cookieData.token;

      headers = {
        ...headers,
        'id': cookieData.id,
        'email': cookieData.email,
        'token': cookieData.token,
      };
    }

    // Handle dev mode URL transformation
    if (process.env.NODE_ENV !== 'production') {
      const devModeState = getDevModeState();
      if (devModeState.isDevMode) {
        // Remove any leading /api or /dev-api
        let url = config.url.replace(/^\/?(api|dev-api)\//, '');
        // Add the correct prefix for dev mode
        config.url = `/dev-api/${url}`;
      } else {
        // Remove any leading /api or /dev-api
        let url = config.url.replace(/^\/?(api|dev-api)\//, '');
        // Add the correct prefix for prod mode
        config.url = `/api/${url}`;
      }
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle global response logic
apiClient.interceptors.response.use(
  response => {
    // Check the errorCode if it exists in the response data
    if (response.data.errorCode) {
      // console.log('Response errorCode:', response.data.errorCode);
      if (response.data.errorCode === 1000 || response.data.errorCode === 1001) {
        // Token expired or invalid, clear the cookie
        clearUserInfo();
      }
    }
    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      // console.log('Unauthorized, redirecting to login');
    }
    // console.error('API request error response:', error.response);
    return Promise.reject(error);
  }
);

// Generic API request function
export const apiRequest = async (method, url, data = null, params = {}) => {
  try {
    // console.log(`This is method: ${method}, this is url: ${url}, this is data:`, data, ' and this is the params:', params);
    
    const response = await apiClient({
      method,
      url, 
      data: data,  // Send data directly without wrapping
      params,
    });
    // console.log('This is the API request response:', response);
    return response.data;
  } catch (error) {
    // console.error(`API request error: ${error}`);
    throw error;
  }
};

export default apiClient;

